import { Chapter, ContentsEntryType, LearningModuleCertification } from 'types/learningHub/moduleContents';
import { CertificationTest } from 'types/module';

export const getInitialSelectedEntry = (chapters: Chapter[]) => {
  const firstLesson = chapters[0].lessons[0];
  const type = (firstLesson?.kind === 'Test' ? 'chapterTest' : 'lesson') as ContentsEntryType;
  const chapterId = chapters[0].id ?? '';
  const entryId = firstLesson?.id ?? '';
  const isCompleted = firstLesson?.isCompleted ?? false;

  return { entryId, type, chapterId, isCompleted };
};

export const getSelectedChapter = (chapters: Chapter[], selectedEntryChapterId: string) => chapters.find((c) => c.id === selectedEntryChapterId);
export const getSelectedLesson = (chapters: Chapter[], selectedEntryChapterId: string, selectedLessonId: string) => getSelectedChapter(chapters, selectedEntryChapterId)?.lessons.find((l) => l.id === selectedLessonId);
export const getSelectedCertification = (certifications: LearningModuleCertification[], selectedCertificationId: string) => certifications.find((c) => c.id === selectedCertificationId);
export const getLessonHeader = (chapters: Chapter[], lessonChapterId: string, lessonId: string): { header: string; subheader: string } => {
    const chapter = getSelectedChapter(chapters ?? [], lessonChapterId ?? '');
    const header =
      chapter && chapters ? `${chapters.indexOf(chapter) + 1}. ${chapter.title ?? ''}` : '';
    const subheader = getSelectedLesson(chapters ?? [], lessonChapterId ?? '', lessonId ?? '')?.title ?? '';
    return { header, subheader };
  };

  export const getCertificationDescription = (certifications: CertificationTest[], selectedCertificationId: string): string => {
    return certifications.find((c) => c.id === selectedCertificationId)?.description ?? '';
  };